import { render, staticRenderFns } from "./ChildBirthAtHome.vue?vue&type=template&id=4a9dfc48&"
import script from "./ChildBirthAtHome.vue?vue&type=script&lang=js&"
export * from "./ChildBirthAtHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports